// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"186":"component---src-pages-privacy-policy-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"108":"771bbb84c51f8ee71b9c","186":"2d28f4ebe9b89183cafe","293":"ab2dae720bab1e0a989f","452":"2b8ca067f6649b6eed65"}[chunkId] + ".js";
};